import { Component } from '@angular/core';
import {NgClass, NgFor, NgIf, NgTemplateOutlet} from "@angular/common";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {AdminSidebarSubmenuComponent} from "../sidebar-submenu/admin-sidebar-submenu.component";
import {SubMenuItem} from "../admin-menu";
import {AdminMenuService} from "../menu.service";
import {TooltipDirective} from "@cybfed/core/utils/tooltip.directive";

@Component({
  selector: 'app-admin-sidebar-menu',
  templateUrl: './admin-sidebar-menu.component.html',
  styleUrl: './admin-sidebar-menu.component.scss',
  standalone: true,
  imports: [
    NgFor,
    NgClass,
    NgTemplateOutlet,
    RouterLink,
    RouterLinkActive,
    NgIf,
    AdminSidebarSubmenuComponent,
    TranslateModule,
    TooltipDirective,
  ],

})
export class AdminSidebarMenuComponent {
  constructor(public menuService: AdminMenuService) {}

  public toggleMenu(subMenu: SubMenuItem) {
    // this.menuService.toggleMenu(subMenu);
  }

  public toggleSubmenu(item: SubMenuItem, event: any) {
    event.preventDefault();
    event.stopPropagation();
    item.expanded = !item.expanded
  }
}
